
import { Base } from '../base-component';
import './self-service-item.component.scss';

export class SelfServiceItem extends Base {

	constructor(element: Element ) {
		super(element);
	}

	init() {}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/self-service-item/self-service-item.component.ts